<div id="pcoded" class="pcoded"
     [attr.nav-type]="navType"
     [attr.theme-layout]="themeLayout"
     [attr.vertical-placement]="verticalPlacement"
     [attr.vertical-layout]="verticalLayout"
     [attr.pcoded-device-type]="pcodedDeviceType"
     [attr.vertical-nav-type]="verticalNavType"
     [attr.vertical-effect]="verticalEffect"
     [attr.vnavigation-view]="vnavigationView"
     [attr.fream-type]="freamType"
     [attr.sidebar-img]="sidebarImg"
     [attr.sidebar-img-type]="sidebarImgType"
     [attr.layout-type]="layoutType"
     (window:resize)="onResize($event)">
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav class="navbar header-navbar pcoded-header hide-for-printing" [attr.header-theme]="headerTheme" [attr.pcoded-header-position]="pcodedHeaderPosition">
      <div class="navbar-wrapper">
        <div class="navbar-logo">
          <a class="mobile-menu" id="mobile-collapse" href="javascript:" (click)="toggleOpened()" [exclude]="'#main_navbar'" (clickOutside)="onClickedOutsideSidebar($event)">
            <i class="ti-menu"></i>
          </a>
          <img class="img-fluid" src="assets/images/GR_logo_white.png" width="110" alt="Theme-Logo" />
          <a href="javascript:" class="mobile-options" (click)="toggleHeaderNavRight()">
            <i class="ti-more"></i>
          </a>
        </div>
        <div class="navbar-container container-fluid">
          <ul class="nav-left">
            <li>
              <div class="sidebar_toggle"><a href="javascript:"><i class="ti-menu"></i></a></div>
            </li>
            <li>
              <div id="titleString" style="color: white; font-size: 16px">{{appTitle.titleString}}</div>
            </li>
          </ul>
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right">
            <li (clickOutside)="notificationOutsideClick('profile')" class="user-profile header-notification" [ngClass]="profileNotificationClass" (click)="toggleProfileNotification()">
              <a href="javascript:">
                <span>{{employeeName}}</span>
                <i class="ti-angle-down"></i>
              </a>
              <ul [@notificationBottom]="profileNotification" class="show-notification profile-notification">
                <li>
                  <a href="javascript:void(0);" (click)="onShowAbout()" style="padding-bottom: 10px; padding-top: 10px" class="no-underline">
                    <i class="ti-info-alt"></i> About&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="onChangeUserInfo()" style="padding-bottom: 10px; padding-top: 10px" class="no-underline">
                    <i class="ti-user"></i> Change My Info&nbsp;&nbsp;&nbsp;
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="onChangePwd()" style="padding-bottom: 10px; padding-top: 10px" class="no-underline">
                    <i class="ti-key"></i> Change Password
                  </a>
                </li>
                <li [hidden]="!browserRegistered">
                  <a href="javascript:void(0);" (click)="onForgetMe()" style="padding-bottom: 10px; padding-top: 10px" class="no-underline">
                    <i class="ti-unlock"></i> Forget Me On This &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Computer&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="onLogout()" style="padding-bottom: 10px; padding-top: 10px" class="no-underline">
                    <i class="ti-back-left"></i> Log Out&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right" [hidden]="nonprofitList.length == 0">
            <li>
              <div style="color: white; font-size: 16px">
                Non-Profit:&nbsp;&nbsp;
                <select (change)='onNonprofitSelected($event)' [(ngModel)]="selectedNonprofitId">
                  <option *ngFor='let option of nonprofitList' [value]="option.optionId" [disabled]="option.optionId == '0'">
                    {{option.optionName}}
                  </option>
                </select>
              </div>
            </li>
          </ul>
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right" [hidden]="nonprofitList.length != 0">
            <li>
              <div style="color: white; font-size: 16px">
                {{nonprofitName}}&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        <nav id="main_navbar"
             class="pcoded-navbar hide-for-printing"
             (clickOutside)="onClickedOutsideSidebar($event)"
             [exclude]="'#mobile-collapse'"
             [attr.pcoded-header-position]="pcodedHeaderPosition"
             [attr.navbar-theme]="navBarTheme"
             [attr.active-item-theme]="activeItemTheme"
             sub-item-theme="theme2"
             active-item-style="style0"
             [attr.pcoded-navbar-position]="pcodedSidebarPosition">
          <div class="pcoded-inner-navbar main-menu" appAccordion>
            <perfect-scrollbar [style.max-width]="'245px'" [style.max-height]="sidebarFixedHeight" [config]="config">
              <span *ngFor="let asideItems of mainMenuItems" class="d-color">
                <div class="pcoded-navigation-label" [attr.menu-title-theme]="menuTitleTheme">{{asideItems.label}}</div>
                <ul class="pcoded-item pcoded-left-item" [attr.item-border]="itemBorder" [attr.item-border-style]="itemBorderStyle" [attr.subitem-border]="subItemBorder" *ngFor="let asideItem of asideItems.main" appAccordionLink group="{{asideItem.state}}">
                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'external'" appAccordionLink group="{{asideItem.state}}">
                    <a href="{{asideItem.external}}" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                      <span class="pcoded-micon"></span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                  </li>

                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'link'" appAccordionLink group="{{asideItem.state}}">
                    <a [routerLink]="['/', asideItem.main_state, asideItem.state]" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle *ngIf="asideItem.main_state; else mainContent">
                      <span class="pcoded-micon"></span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ng-template #mainContent>
                      <a [routerLink]="['/', asideItem.state]" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle (click)="onMainMenuChildItemClicked(asideItem.name, $event)">
                        <span class="pcoded-micon"></span>
                        <span class="pcoded-mtext">{{ asideItem.name }}</span>
                        <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                    </ng-template>
                  </li>
                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'sub'" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" appAccordionLink group="{{asideItem.state}}">
                    <a [routerLinkActive]="['active']" href="javascript:;" appAccordionToggle (click)="onMainMenuParentItemClicked(asideItem, $event)">
                      <span class="pcoded-micon"></span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ul class="pcoded-submenu">
                      <ng-template ngFor let-asideChildren [ngForOf]="asideItem.children">
                        <li [routerLinkActive]="['active']" *ngIf="asideChildren.type !== 'sub'">
                          <a [routerLink]="['/', asideItem.state, asideChildren.state]" target="{{asideChildren.target ? '_blank' : '_self'}}" (click)="onMainMenuChildItemClicked(asideChildren.name, $event)">
                            <span class="pcoded-micon"><i class="ti-angle-right"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name }} </span>
                            <span *ngFor="let asideChildrenBadge of asideChildren.badge" class="pcoded-badge label label-{{ asideChildrenBadge.type }}">{{asideChildrenBadge.value}}</span>
                            <span class="pcoded-mcaret"></span>
                          </a>
                        </li>

                        <li [routerLinkActive]="['active']" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" *ngIf="asideChildren.type === 'sub'" appAccordionLink group="sub-toggled">
                          <a href="javascript:;" appAccordionToggle>
                            <span class="pcoded-micon"><i class="ti-direction-alt"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name }}</span>
                            <span *ngFor="let asideChildrenBadge of asideChildren.badge" class="pcoded-badge label label-{{ asideChildrenBadge.type }}">{{asideChildrenBadge.value}}</span>
                            <span class="pcoded-mcaret"></span>
                          </a>
                          <ul class="pcoded-submenu">
                            <ng-template ngFor let-asideChildrenSub [ngForOf]="asideChildren.children">
                              <li [routerLinkActive]="['active']">
                                <a [routerLink]="['/', asideItem.state, asideChildren.state, asideChildrenSub.state]" target="{{asideChildrenSub.target ? '_blank' : '_self'}}">
                                  <span class="pcoded-micon"><i class="ti-angle-right"></i></span>
                                  <span class="pcoded-mtext">{{ asideChildrenSub.name }}</span>
                                  <span *ngFor="let asideChildrenSubBadge of asideChildrenSub.badge" class="pcoded-badge label label-{{ asideChildrenSubBadge.type }}">{{asideChildrenSubBadge.value}}</span>
                                  <span class="pcoded-mcaret"></span>
                                </a>
                              </li>
                            </ng-template>
                          </ul>
                        </li>
                      </ng-template>
                    </ul>
                  </li>
                </ul>
              </span>
            </perfect-scrollbar>
          </div>
        </nav>
        <div class="pcoded-content">
          <div class="pcoded-inner-content">
            <!-- Main-body start -->
            <div class="main-body">
              <div id="pageWrapper" class="page-wrapper">
                <app-card style="position: relative; display: none;">
                  <h6 style="margin-bottom: 10px" class="modal-title">Select a link to navigate to a {{parentMenuName}} screen</h6>
                  <ul style="list-style-type: square; margin-left: 17px">
                    <li *ngFor="let row of rowDataNavigationPage">
                      <a [routerLink]="row.url" style="font-size:medium" (click)="onMainMenuChildItemClicked(row.caption)" title="{{row.tooltip}}">{{row.caption}}</a>
                    </li>
                  </ul>
                </app-card>
                <router-outlet>
                  <app-title #appTitle></app-title>
                  <app-spinner></app-spinner>
                </router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-basic #modalHelpAbout>
  <div class="app-modal-header modal-padding">
    <h4 class="modal-title">About GiftReporter</h4>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr>
        <td style="padding-bottom: 15px"><b>GiftReporter</b></td>
      </tr>
      <tr>
        <td style="padding-bottom: 15px">???</td>
      </tr>
      <tr>
        <td style="padding-bottom: 15px">Build Version: 1.0</td>
      </tr>
      <tr>
        <td style="padding-bottom: 15px"><a target="_blank" href="https://???.com/">https://???.com</a></td>
      </tr>
      <tr>
        <td style="padding-bottom: 15px; white-space: pre-wrap">{{getCurrentYear()}} GiftReporter All Rights Reserved</td>
      </tr>
      <tr>
        <td style="white-space: pre-wrap">Unauthorized access to this system is prohibited by law — Title 18 U.S. Code Section 1030</td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" id="aboutModalOkButton" (click)="modalHelpAbout.hide()">OK</button>
  </div>
</app-modal-basic>

<app-modal-basic #modalChangePwd>
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">Change password for {{employeeName}}</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr [hidden]="!showPasswordErrorMsg">
        <td></td>
        <td style="color: red; white-space: pre-wrap;">
          {{passwordErrorMsg}}
        </td>
      </tr>
      <tr>
        <td>Old Password</td>
        <td style="position:relative">
          <input [type]="revealPwd1 ? 'text' : 'password'" [(ngModel)]="passwordOld" maxlength="45" class="form-control" (keydown.enter)="finishChangePwd()" id="passwordOld">
          <i class="ti-eye" style="transform: scale(2); position:absolute; right:11px; top:10.5px; cursor: pointer; z-index:9999" (click)="revealPwd1 = !revealPwd1" title="Show/hide password"></i>
        </td>
      </tr>
      <tr>
        <td>New password</td>
        <td style="position:relative">
          <input [type]="revealPwd2 ? 'text' : 'password'" [(ngModel)]="passwordNew" maxlength="45" class="form-control" (keydown.enter)="finishChangePwd()">
          <i class="ti-eye" style="transform: scale(2); position:absolute; right:11px; top:10.5px; cursor: pointer; z-index:9999" (click)="revealPwd2 = !revealPwd2" title="Show/hide password"></i>
        </td>
      </tr>
      <tr>
        <td>Confirm password&nbsp;</td>
        <td style="position:relative">
          <input [type]="revealPwd3 ? 'text' : 'password'" [(ngModel)]="passwordConfirm" maxlength="45" class="form-control" (keydown.enter)="finishChangePwd()">
          <i class="ti-eye" style="transform: scale(2); position:absolute; right:11px; top:9.5px; cursor: pointer; z-index:9999" (click)="revealPwd3 = !revealPwd3" title="Show/hide password"></i>
        </td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="finishChangePwd()">Save</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" (click)="modalChangePwd.hide(); revealPwd1 = false; revealPwd2 = false; revealPwd3 = false;">Cancel</button>
  </div>
</app-modal-basic>

<app-modal-basic #modalChangeUserInfo>
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">Change info for {{employeeName}}</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr [hidden]="!showInfoErrorMsg">
        <td></td>
        <td style="color: red; white-space: pre-wrap;">
          {{infoErrorMsg}}
        </td>
      </tr>
      <tr>
        <td>New Email</td>
        <td>
          <input type="text" [(ngModel)]="newEmail" maxlength="45" class="form-control" (keydown.enter)="finishChangeUserInfo()" id="newEmail" trimOnBlur>
        </td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="finishChangeUserInfo()">Save</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" (click)="modalChangeUserInfo.hide()">Cancel</button>
  </div>
</app-modal-basic>

<message-box #msgBox></message-box>
